import React from 'react';
import { LOGO_TILE_PADDING_PX } from '../utils/branding';

/**
 * Company logo in the sidebar (or preview): optional rounded corners and soft “tile” backing for boxy / white-background assets.
 * @param {{
 *   src: string;
 *   alt: string;
 *   isCustomCompanyLogo: boolean;
 *   maxWidth: number;
 *   maxHeight: number;
 *   cornerRadius: number;
 *   backing: 'none' | 'white' | 'black' (legacy 'panel' is treated as white);
 *   defaultLogoStyle?: object;
 * }} props
 */
export default function BrandedSidebarLogo({
  src,
  alt,
  isCustomCompanyLogo,
  maxWidth,
  maxHeight,
  cornerRadius,
  backing,
  defaultLogoStyle,
}) {
  if (!isCustomCompanyLogo) {
    return <img src={src} alt={alt} style={defaultLogoStyle} />;
  }

  /** @type {'none' | 'white' | 'black'} */
  const effective = backing === 'panel' ? 'white' : backing;
  const useTile = effective === 'white' || effective === 'black';
  const outerRadius = useTile ? Math.max(cornerRadius, 8) : cornerRadius;
  const needsWrapper = useTile || cornerRadius > 0;

  const imgStyle = {
    maxWidth: `${maxWidth}px`,
    width: 'auto',
    height: 'auto',
    maxHeight: `${maxHeight}px`,
    objectFit: 'contain',
    display: 'block',
    borderRadius: !useTile && cornerRadius > 0 ? cornerRadius : 0,
  };

  if (!needsWrapper) {
    return <img src={src} alt={alt} style={imgStyle} />;
  }

  const tileBg =
    effective === 'white' ? '#ffffff' : effective === 'black' ? '#0a0a0a' : undefined;
  const tileShadow =
    effective === 'white'
      ? '0 1px 3px rgba(15,23,42,0.08)'
      : effective === 'black'
        ? '0 1px 4px rgba(0,0,0,0.5)'
        : undefined;

  const wrapperStyle = {
    display: 'inline-block',
    padding: useTile ? LOGO_TILE_PADDING_PX : 0,
    borderRadius: outerRadius,
    overflow: 'hidden',
    lineHeight: 0,
    background: useTile ? tileBg : undefined,
    boxShadow: useTile ? tileShadow : undefined,
  };

  return (
    <span style={wrapperStyle}>
      <img src={src} alt={alt} style={imgStyle} />
    </span>
  );
}
